import React from 'react';

export default {
    Eng: {
        formTitle: "IRIS Online Services - Enquiry Form", 
        steps_Particulars: "Particulars",

        PICSContent: ()=>      [<> 
            <p>1. <span style={{textDecoration:"underline"}}>Purpose of Collection</span></p>
            <p>
                The personal data collected in this form will be used by the Land Registry for the following purposes:-
                <ol style={{listStyleType: "lower-latin"}}>
                    <li>to carry out activities relating to the provision of services by the Land Registry;</li>
                    <li>to facilitate communications; and</li>
                    <li>to produce statistics relating to the Land Registry’s services.</li>
                </ol>
            </p>
            <p>
                You understand that the provision of your personal data is voluntary. If you fail to provide information as required in this form, the Land Registry may not be able to provide the requested service.
            </p>
            <p>
                Please do NOT provide any personal data (including personal data relating to third parties) which are not specifically required to be submitted. Where information of any third party is included in this form or any document(s) filed in relation to it, the Land Registry will treat that you have obtained consent from such third party to disclose such information for the purposes above.
            </p>
            
            <p>2. <span style={{textDecoration:"underline"}}>Disclosure of Personal Data</span></p>
            <p>
                You understand that the personal data provided in this form may be disclosed or transferred to parties relevant where such disclosure or transfer is necessary for the purposes as stated in paragraph 1 above.
            
            </p>    
            <p>3. <span style={{textDecoration:"underline"}}>Access to Personal Data</span></p>
            <p>
                You understand that pursuant to Sections 18 and 22 and Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance (Cap. 486) (“<span style={{fontWeight:"bold"}}>PDPO</span>”), you have the right to request access to and correction of your personal data held by the Land Registry. Under PDPO, the Land Registry is entitled to charge a fee to process the said request. Any such request shall be made to the Personal Data (Privacy) Officer of the Land Registry at 28th Floor, Queensway Government Offices, 66 Queensway, Hong Kong.
            </p>
            </>
        ],

        // Form fields
        part_1_Particulars:         "Part I - Customer's Particulars", 
        part_2_OrderDetails:        "Part II - Order Details", 
        part_3_Issues:              "Part III - Enquiry Issues", 
        part_4_SignatoryDetails:    "Part IV - Signatory Details",                  
        
        // Form - Part1
        OlsAccName:     "Subscriber Account Name / Name of Customer", 
        OlsAccNo:       "Subscriber Account No.",
        ContactPerson:  "Name of Contact Person", 
        ContactPhone:   "Contact Telephone No.", 
        ContactEmail:   "Email Address", 

        // Form - Part2
        TransOrder:         "Transaction Reference Type",         
        field_transOrder_list:[
            {id: "TransOrder", value: "NaN_Trans_Opt_1", text: "Payment Transaction No."},
            {id: "TransOrder", value: "NaN_Trans_Opt_2", text: "Order No." },
        ],
        TransactionNo:      "Payment Transaction No.", 
        OrderNo:            "Order No.", 
        DateOfOrder:        "Date of Order", 
        TimeOfOrder:        "Time of Order", 
        OrderType:          "Order Type", 
        OrderType_Other:    "Order Type - Other",
        field_orderType_list:[
            {id: "OrderType", value: "NaN_OrderType_Opt_1", text: "Land Register"},
            {id: "OrderType", value: "NaN_OrderType_Opt_2", text: "Land Document"},
            {id: "OrderType", value: "NaN_OrderType_Opt_3", text: "Unposted Memorial Information"},
            {id: "OrderType", value: "NaN_OrderType_Opt_4", text: "Others"},
        ],
        field_refType_list:[
            {id: "RefType", value: "NaN_RefType_Opt_1", text: "Property Address"},
            {id: "RefType", value: "NaN_RefType_Opt_2", text: "Lot No."},
            {id: "RefType", value: "NaN_RefType_Opt_3", text: "Property Reference No."},
            {id: "RefType", value: "NaN_RefType_Opt_4", text: "Memorial No."},
        ],

        // Form - Matter
        Problems1:          "Advice on how to search the land register", 

        Problems2:          "Clarification on information in the land register", 
        LandRegisterAttach: "Copy of the Register", 

        Problems3:          "Problem in image", 
        ImageProblem:       "Type of Image Problem",         
        field_imageProblem_list:[
            {id: "ImageProblem", value: "NaN_Image_Opt_1", text: "Unclear"},
            {id: "ImageProblem", value: "NaN_Image_Opt_2", text: "Incomplete"},
            {id: "ImageProblem", value: "NaN_Image_Opt_3", text: "Blank page(s)"},
        ],
        ImageAttach:        "Copy of affected pages", 

        Problems4:          "Wrong Document", 
        WrongDocAttach:     "Copy of first two pages of document", 

        Problems5:          "Problem in receiving the ordered land record(s) and request for re-sending the land record(s) to", 
        RequestFor:         "Email Address / Fax No.", 
        
        Problems6:          "Others", 
        Others:             "Details", 

        // Form - Part3
        NameEN:             "Name of Signatory", 
    }
};